<template>
    <div style="width:100%;">
        Enter in 1 to 4 of the following text boxes. The input forms of each group can be mixed.<br/>
        <div style="width:24%;display: inline-block;">
            <p>
                SNP<a href="javascript:void(0)" @click="fillText('snp')">(example)</a><br/>SNP id/aliases or Gene name
            </p>
            <el-input
                type="textarea"
                class="search"
                :rows="5"
                placeholder="Please enter your list here"
                resize=none
                v-model="snpText">
            </el-input>
         </div>
        <div style="width:24% ;display: inline-block;">
            <p>
            Gene<a href="javascript:void(0)" @click="fillText('gene')">(example)</a><br/>Gene name/ID/aliases
            </p>
            <el-input
                type="textarea"
                class="search"
                :rows="5"
                placeholder="Please enter your list here"
                resize=none
                v-model="geneText">
            </el-input>
        </div>
        <div style="width:24%;display: inline-block;">
            <p>
                RNA<a href="javascript:void(0)" @click="fillText('rna')">(example)</a><br/>Gene name/ID/aliases or Original name
            </p>
            <el-input
                type="textarea"
                class="search"
                :rows="5"
                placeholder="Please enter your list here"
                resize=none
                v-model="rnaText">
            </el-input>
         </div>
         <div style="width:24%;display: inline-block;">
            <p>
                Methylation<a href="javascript:void(0)" @click="fillText('methylation')">(example)</a><br/>Gene name/ID/aliases or Probe ID
            </p>
            <el-input
                type="textarea"
                class="search"
                :rows="5"
                placeholder="Please enter your list here"
                resize=none
                v-model="methylationText">
            </el-input>
         </div>
         <el-button size="small" @click="submit" type="warning" style="width:95%;font-size: 20px;margin-top: 10px;height:40px">Submit</el-button> 
        <div id="plot">
            <NetworkchartVue :nodes="nodes" :edges="edges" v-if="showChart"></NetworkchartVue>
        </div>
    </div>
</template>

<script>
import{Loading}from'element-ui';
import NetworkchartVue from '../../../chart/Networkchart.vue'
export default {
    components:{
        NetworkchartVue
    },
    data(){
        return{
            snpText:null,
            geneText:null,
            rnaText:null,
            methylationText:null,
            
            snpArray:[],
            geneArray:[],
            rnaArray:[],
            methylationArray:[],

            tableData:null,

            nodes:[
                {
                    name:'Major depressive disorder',
                    id:'Major depressive disorder',
                },
                {
                    name:'Bipolar disorder',
                    id:'Bipolar disorder',
                },
                {
                    name:'Schizophrenia',
                    id:'Schizophrenia',
                },
                {
                    name:'Anxiety disorder',
                    id:'Anxiety disorder',
                }
            ],
            edges:[],
            showChart:false
        }
    },
    methods:{
        fillText(omics){
            switch(omics){
                case 'snp':
                  this.snpText='rs1006737\nZKSCAN4\nrs58841535';
                  return ;
                case 'gene':
                  this.geneText='1\nBDNF\nPKBG\nSRA1\n100';
                  return ;
                case 'rna':
                  this.rnaText='SNORD115-8\n100128640\n406952\nU91319.1';
                  return ;
                case 'methylation':
                  this.methylationText='cg05986831\n7879\nKvb1.3\nHBII-52-29';
                  return ;
            }
         },
        getData(){
            var loadingInstance = Loading.service({
                target:document.querySelector('#plot')
            });
            this.axios.get(this.GLOBAL.rootAddress+'visualization/Relation',{
            params: { 
                 'snp':this.snpArray+"",
                 'gene':this.geneArray+"",
                 'rna':this.rnaArray+"",
                 'methylation':this.methylationArray+""
                }
            })
            .then(response=> {        
                loadingInstance.close();     
                this.tableData=response.data;
                this.getNetwork()
            })
            .catch(error=> {
                loadingInstance.close();    
                console.log(error);
            });
        },
        submit(){
            this.nodes=[
                {
                    name:'Major depressive disorder',
                    id:'Major depressive disorder',
                    symbolSize:20,
                    label:{
                        fontSize: 17,
                        color:'rgb(132,25,199)'
                    },
                    itemStyle: {
                        color: 'rgb(132,25,199)'
                    }
                },{
                    name:'Bipolar disorder',
                    id:'Bipolar disorder',
                    symbolSize:20,
                    label:{
                        fontSize: 17,
                        color:'rgb(132,25,199)'
                    },
                    itemStyle: {
                        color: 'rgb(132,25,199)'
                    }
                },{
                    name:'Schizophrenia',
                    id:'Schizophrenia',
                    symbolSize:20,
                    label:{
                        fontSize: 17,
                        color:'rgb(132,25,199)'
                    },
                    itemStyle: {
                        color: 'rgb(132,25,199)'
                    }
                },{
                    name:'Anxiety disorder',
                    id:'Anxiety disorder',
                    symbolSize:20,
                    label:{
                        fontSize: 17,
                        color:'rgb(132,25,199)'
                    },
                    itemStyle: {
                        color: 'rgb(132,25,199)'
                    }
                }
            ],
            this.edges=[]
            if(this.snpText){
                this.snpArray=this.snpText.split(/[(\r\n)\r\n]+/)
                this.snpArray = this.snpArray.filter((s) => {return s && s.trim(); });
                  this.snpArray=this.snpArray.map(function (item) {
                     return(item.trim())
                });
            }else this.snpArray=[]
            if(this.geneText){
                this.geneArray=this.geneText.split(/[(\r\n)\r\n]+/)
                this.geneArray = this.geneArray.filter((s) => {return s && s.trim(); });
                  this.geneArray=this.geneArray.map(function (item) {
                     return(item.trim())
                  });
            }else this.geneArray=[]
            if(this.rnaText){
                this.rnaArray=this.rnaText.split(/[(\r\n)\r\n]+/)
                this.rnaArray = this.rnaArray.filter((s) => {return s && s.trim(); });
                  this.rnaArray=this.rnaArray.map(function (item) {
                     return(item.trim())
                  });
            }else this.rnaArray=[]
            if(this.methylationText){
                this.methylationArray=this.methylationText.split(/[(\r\n)\r\n]+/)
                this.methylationArray = this.methylationArray.filter((s) => {return s && s.trim(); });
                  this.methylationArray=this.methylationArray.map(function (item) {
                     return(item.trim())
                  });
            }else this.methylationArray=[]
            
            if(this.snpArray.length>50||this.geneArray>50||this.rnaArray>50||this.methylationArray>50){
                  this.$message.error('The input cannot exceed 50 entries.');
                  this.snpArray=[]
                  this.geneArray=[]
                  this.rnaArray=[]
                  this.methylationArray=[]
                  return;
            }
            this.showChart=true
            this.getData()
        },
        getNetwork(){
            // this.showChart=true
            this.tableData.snp.forEach((ele) => {
                this.nodes.push({
                    id:ele.snp,
                    name: ele.snp,
                    chromosome:ele.chromosome,
                    position:ele.position,
                    allele:ele.allele,
                    gene:ele.gene,
                    category:'SNP'
                });
                var edge_width=ele.score_dgn?(parseFloat(ele.score_dgn)*5+2):1.5
                this.edges.push({
                    source:ele.snp,
                    target:ele.disease,
                    score:ele.score_dgn,
                    lineStyle: {
                        width:edge_width
                    },
                })
            })
            this.tableData.gene.forEach((ele) => {
                this.nodes.push({
                    id:ele.gene_name,
                    name: ele.gene_name,
                    gene_id:ele.gene_id,
                    location:ele.map_location,
                    type:ele.gene_type,
                    category:'Gene'
                });
                var edge_width=ele.score_dgn?(parseFloat(ele.score_dgn)*5+2):1.5
                this.edges.push({
                    source:ele.gene_name,
                    target:ele.disease,
                    score:ele.score_dgn,
                    lineStyle: {
                        width:edge_width
                    },
                })
            })
            this.tableData.rna.forEach((ele) => {
                var tmpName
                if(ele.gene_name!=null)tmpName=ele.gene_name
                else tmpName=ele.rna_name
                this.nodes.push({
                    id:tmpName,
                    name: tmpName,
                    gene_id:ele.gene_id,
                    rna_name:ele.rna_name,
                    location:ele.map_location,
                    type:ele.gene_type,
                    category:'RNA'
                });
                var edge_width=ele.score_dgn?(parseFloat(ele.score_dgn)*5+2):1.5
                this.edges.push({
                    source:tmpName,
                    target:ele.disease,
                    score:ele.score_dgn,
                    lineStyle: {
                        width:edge_width
                    },
                })
            })
            this.tableData.methy.forEach((ele) => {
                if(ele.gene_name){
                    this.nodes.push({
                        id:ele.gene_name,
                        name: ele.gene_name,
                        gene_name:ele.gene_name,
                        gene_id:ele.gene_id,
                        probe:ele.probe,
                        location:ele.map_location,
                        category:'Methylation'
                    });
                    this.edges.push({
                        source:ele.gene_name ,
                        target:ele.disease,
                        score:null,
                        lineStyle: {
                            width:1.5
                        },
                    })
                }else{
                    this.nodes.push({
                        id:ele.probe,
                        name: ele.probe,
                        gene_name:ele.gene_name,
                        gene_id:ele.gene_id,
                        probe:ele.probe,
                        location:ele.map_location,
                        type:ele.gene_type,
                        category:'methylation'
                    });
                    this.edges.push({
                        source:ele.probe ,
                        target:ele.disease,
                        score:null,
                        lineStyle: {
                            width:0.2
                        },
                    })
                }
               
            })
            this.nodes=this.uniqueArray(this.nodes,'name')
        },
        uniqueArray(array, key){
            var result = [array[0]];
            for(var i = 1; i < array.length; i++){
                var item = array[i];
                var repeat = false;
                for (var j = 0; j < result.length; j++) {
                    if (item[key] == result[j][key]) {
                        repeat = true;
                        break;
                    }
                }
                if (!repeat) {
                    result.push(item);
                }
            }
            return result;
        }
    }
}
</script>